import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { useAppContext } from '../context/AppContext';

const Sidebar = () => {
  const { t } = useAppContext();

  const navItems = [
    { path: '/', name: t('nav.dashboard'), icon: 'PieChart' },
    { path: '/orders', name: t('nav.orders'), icon: 'ShoppingCart' },
    { path: '/production', name: t('nav.production'), icon: 'Activity' },
    { path: '/print', name: t('nav.printCentre'), icon: 'Printer' },
    { separator: true },
    { path: '/products', name: t('nav.products'), icon: 'Box' },
    { path: '/recipes', name: t('nav.recipes'), icon: 'FileText' },
    { path: '/customers', name: t('nav.customers'), icon: 'Users' },
    { path: '/assignments', name: t('nav.assignments'), icon: 'Link' },
    { separator: true },
    { path: '/order-form', name: t('nav.orderForm'), icon: 'Globe' },
    { path: '/settings', name: t('nav.settings'), icon: 'Settings' },
  ];

  return (
    <aside className="w-64 bg-white border-r border-gray-200 flex flex-col print:hidden shadow-sm h-screen sticky top-0">
      <div className="p-6 flex items-center gap-3 border-b border-gray-100">
        <div className="bg-amber-100 text-amber-600 p-2 rounded-lg">
          <SafeIcon name="Briefcase" className="w-6 h-6" />
        </div>
        <h1 className="font-bold text-xl text-gray-800 tracking-tight">BakeryPro</h1>
      </div>

      <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
        {navItems.map((item, idx) => {
          if (item.separator) {
            return <div key={idx} className="h-px bg-gray-100 my-4 mx-2" />;
          }
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors duration-200 text-sm font-medium ${
                  isActive ? 'bg-amber-50 text-amber-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`
              }
            >
              <SafeIcon name={item.icon} className="w-4 h-4" />
              {item.name}
            </NavLink>
          );
        })}
      </nav>

      <div className="p-4 border-t border-gray-100 text-xs text-gray-400 text-center">
        MVP Version 1.1
      </div>
    </aside>
  );
};

export default Sidebar;